module.exports = __webpack_public_path__ + "img/delivery_zones.f8b7deee.svg";